import { render, staticRenderFns } from "./KalenderKachel.vue?vue&type=template&id=7c18f3a9&scoped=true"
import script from "./KalenderKachel.vue?vue&type=script&lang=js"
export * from "./KalenderKachel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c18f3a9",
  null
  
)

export default component.exports